import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import ParallaxBreak from './components/ParallaxBreak';
import HowItWorks from './components/HowItWorks';
import Vacancies from './components/Vacancies';
import ContactSection from './components/ContactSection';
import ContactPage from './pages/ContactPage';
import Login from './pages/Login';
import ContactSubmissionDetail from './pages/ContactSubmissionDetail';
import Dashboard from './pages/Dashboard';
import NotFound from './pages/NotFound';
import SharedDocument from './pages/SharedDocument';
import Registreren from './pages/Registreren';
import Mijn, { MijnLink, MijnVergeten } from './pages/Mijn';
import { useParams } from 'react-router-dom';

// Nieuwe weergave op /nieuw/<tab>: zelfde dashboard, ander ontwerp.
function DashboardNieuw() {
  const { tab } = useParams();
  return <Dashboard tab={tab || 'calendar'} skin="nieuw" />;
}
import Footer from './components/Footer';
import './App.css';

// Main landing page component
const HomePage = () => {
  return (
    <main className="home-page">
      <Navbar />
      <Hero />
      <About />
      <ParallaxBreak />
      <HowItWorks />
      <Vacancies />
      <ContactSection />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/CONTACT" element={<ContactPage />} />

          {/* Login route */}
          <Route path="/login" element={<Login />} />
          {/* Legacy login path — redirect to /login */}
          <Route path="/dashboard/login" element={<Navigate to="/login" replace />} />
          <Route path="/DASHBOARD/LOGIN" element={<Navigate to="/login" replace />} />

          {/* Protected dashboard routes */}
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard tab="calendar" /></ProtectedRoute>} />
          <Route path="/dashboard/calendar" element={<ProtectedRoute><Dashboard tab="calendar" /></ProtectedRoute>} />
          <Route path="/dashboard/workers" element={<ProtectedRoute><Dashboard tab="workers" /></ProtectedRoute>} />
          <Route path="/dashboard/certificaten" element={<ProtectedRoute><Dashboard tab="certificaten" /></ProtectedRoute>} />
          <Route path="/dashboard/po" element={<ProtectedRoute><Dashboard tab="po" /></ProtectedRoute>} />
          <Route path="/dashboard/whatsapp" element={<ProtectedRoute><Dashboard tab="whatsapp" /></ProtectedRoute>} />
          <Route path="/nieuw" element={<ProtectedRoute><DashboardNieuw /></ProtectedRoute>} />
          <Route path="/nieuw/:tab" element={<ProtectedRoute><DashboardNieuw /></ProtectedRoute>} />
          <Route path="/dashboard/id-vaststelling" element={<ProtectedRoute><Dashboard tab="id-vaststelling" /></ProtectedRoute>} />
          <Route path="/dashboard/clients" element={<ProtectedRoute><Dashboard tab="clients" /></ProtectedRoute>} />
          <Route path="/dashboard/aanvragen" element={<ProtectedRoute><Dashboard tab="aanvragen" /></ProtectedRoute>} />
          <Route path="/dashboard/aanvragen/:id" element={<ProtectedRoute><ContactSubmissionDetail /></ProtectedRoute>} />
          <Route path="/dashboard/logboek" element={<ProtectedRoute><Dashboard tab="logboek" /></ProtectedRoute>} />
          <Route path="/dashboard/shifts" element={<ProtectedRoute><Dashboard tab="shifts" /></ProtectedRoute>} />
          <Route path="/dashboard/assignments" element={<ProtectedRoute><Dashboard tab="assignments" /></ProtectedRoute>} />
          <Route path="/dashboard/urenlijst" element={<ProtectedRoute><Dashboard tab="urenlijst" /></ProtectedRoute>} />
          <Route path="/dashboard/documents" element={<ProtectedRoute><Dashboard tab="documents" /></ProtectedRoute>} />
          <Route path="/dashboard/zzp-contracts" element={<ProtectedRoute><Dashboard tab="zzp-contracts" /></ProtectedRoute>} />
          <Route path="/dashboard/zzp-functiegroepen" element={<ProtectedRoute><Dashboard tab="zzp-functiegroepen" /></ProtectedRoute>} />
          <Route path="/dashboard/zzp-werkzaamheden" element={<ProtectedRoute><Dashboard tab="zzp-werkzaamheden" /></ProtectedRoute>} />
          <Route path="/dashboard/zzp-opdrachtgevers" element={<ProtectedRoute><Dashboard tab="zzp-opdrachtgevers" /></ProtectedRoute>} />
          {/* Uppercase versions */}
          <Route path="/DASHBOARD" element={<ProtectedRoute><Dashboard tab="calendar" /></ProtectedRoute>} />
          <Route path="/DASHBOARD/CALENDAR" element={<ProtectedRoute><Dashboard tab="calendar" /></ProtectedRoute>} />
          <Route path="/DASHBOARD/WORKERS" element={<ProtectedRoute><Dashboard tab="workers" /></ProtectedRoute>} />
          <Route path="/DASHBOARD/CERTIFICATEN" element={<ProtectedRoute><Dashboard tab="certificaten" /></ProtectedRoute>} />
          <Route path="/DASHBOARD/PO" element={<ProtectedRoute><Dashboard tab="po" /></ProtectedRoute>} />
          <Route path="/DASHBOARD/WHATSAPP" element={<ProtectedRoute><Dashboard tab="whatsapp" /></ProtectedRoute>} />
          <Route path="/DASHBOARD/CLIENTS" element={<ProtectedRoute><Dashboard tab="clients" /></ProtectedRoute>} />
          <Route path="/DASHBOARD/SHIFTS" element={<ProtectedRoute><Dashboard tab="shifts" /></ProtectedRoute>} />
          <Route path="/DASHBOARD/ASSIGNMENTS" element={<ProtectedRoute><Dashboard tab="assignments" /></ProtectedRoute>} />
          <Route path="/DASHBOARD/URENLIJST" element={<ProtectedRoute><Dashboard tab="urenlijst" /></ProtectedRoute>} />
          <Route path="/DASHBOARD/LOGBOEK" element={<ProtectedRoute><Dashboard tab="logboek" /></ProtectedRoute>} />
          {/* Public shared document page — no auth required */}
          <Route path="/doc/:token" element={<SharedDocument />} />
          <Route path="/registreren/:token" element={<Registreren />} />
          <Route path="/mijn" element={<Mijn />} />
          <Route path="/mijn/link/:token" element={<MijnLink />} />
          <Route path="/mijn/wachtwoord-vergeten" element={<MijnVergeten />} />
          <Route path="/dashboard/meldingen" element={<ProtectedRoute><Dashboard tab="meldingen" /></ProtectedRoute>} />
          {/* Catch-all */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
